import { makeAutoObservable, toJS } from "mobx";
import apiRequest from "../api/api.request";
import utilitState from "./utilit.state";

class controllerState {
  constructor() {
    makeAutoObservable(this);
  }
  controllers = [];
  logs_event = [];
  this_controller = [];
  list_category = [];
  controller_id = null;
  funcTagMoveData = null;
  history_controller = [];
  history_date = [];
  history_controller_original = [];
  history_date_original = [];
  history_page = 1;
  history_next_page = 0;
  history_previous_page = 0;
  history_size = 100;
  tag_value = "";
  data_from = "";
  data_to = "";

  setHistoryPagination = (payload) => {
    if (!payload) return;
    this.history_page = payload.page ?? 1;
    this.history_next_page = payload.next_page ?? 0;
    this.history_previous_page = payload.previous_page ?? 0;
    this.history_size = payload.size ?? 100;
  };

  setParameters = (parametr, value) => {
    this[`${parametr}`] = value;
  };

  nameError = ["ошибка", "error", "err"];

  sortAB = (data, name) => {
    data.sort((a, b) => {
      if (a[name] < b[name]) {
        return -1;
      }
      if (a[name] > b[name]) {
        return 1;
      }
      return 0;
    });
  };

  creatGroupFreeCategory = async () => {
    try {
      const res = await apiRequest.getAllCategory();
      if (res) {
        console.log("creatGroupFreeCategory", res);
        res.map((c) => {
          const categoryID = this.list_category.find((lc) => lc.id === c.id);
          if (categoryID) return;
          console.log(c);
          this.list_category = [
            ...this.list_category,
            {
              name: c.categories_controller,
              update: false,
              id: c.id,
              visible: false,
              data: [],
            },
          ];
        });
      }

      console.log("this.list_category", toJS(this.list_category));
    } catch (e) {
      console.error(e);
    } finally {
      this.sortAB(this.list_category, "name");
    }
  };

  tagIdsKey = (list) =>
    Array.isArray(list) ? list.map((t) => t.id_tag).join(",") : "";

  applyTagSnapshot = (target, source) => {
    if (!target || !source) return;
    target.parameter_value = source.parameter_value;
    if (source.tag_name != null) target.tag_name = source.tag_name;
    if (source.name_tag != null) target.name_tag = source.name_tag;
  };

  syncTagListInPlace = (currentList, incomingList) => {
    if (!Array.isArray(incomingList)) {
      return { ok: false };
    }
    const current = Array.isArray(currentList) ? currentList : [];
    if (this.tagIdsKey(current) !== this.tagIdsKey(incomingList)) {
      return { ok: false };
    }
    incomingList.forEach((src) => {
      const item = current.find((t) => t.id_tag === src.id_tag);
      this.applyTagSnapshot(item, src);
    });
    return { ok: true };
  };

  createController = async (id) => {
    this.list_category = [];
    this.this_controller = await apiRequest.getLogController(id, true);
    if (!this.this_controller?.tags) {
      return;
    }
    this.this_controller.tags.forEach((t) => {
      this.list_category = [
        ...this.list_category,
        {
          name: t.category_name,
          update: false,
          id: t.category_id,
          visible: true,
          data: t.controller_data,
        },
      ];
      t.update = false;
      this.sortAB(t.controller_data, "name_tag");
    });

    this.creatGroupFreeCategory();
  };

  refreshControllerData = async (id) => {
    const fresh = await apiRequest.getLogController(id, true);
    if (!fresh?.tags) {
      return;
    }

    const ready =
      this.this_controller &&
      !Array.isArray(this.this_controller) &&
      Array.isArray(this.list_category) &&
      this.list_category.length > 0;

    if (!ready) {
      return;
    }

    for (const tagGroup of fresh.tags) {
      const cat = this.list_category.find((c) => c.id === tagGroup.category_id);
      if (!cat) {
        await this.createController(id);
        return;
      }
      const sync = this.syncTagListInPlace(cat.data, tagGroup.controller_data);
      if (!sync.ok) {
        cat.data = tagGroup.controller_data;
        this.sortAB(cat.data, "name_tag");
      }
    }

    const notTags = this.this_controller.not_tags;
    const syncNot = this.syncTagListInPlace(notTags, fresh.not_tags);
    if (!syncNot.ok) {
      this.this_controller.not_tags = fresh.not_tags || [];
      this.sortAB(this.this_controller.not_tags, "name_tag");
    }
  };

  setControllers = async (controllers) => {
    this.controllers = controllers;
  };

  updateCategoryBoolean = (name, id) => {
    const categoryID = this.list_category.find((c) => c.id === id);
    if (categoryID) {
      categoryID[name] = !categoryID[name];
    }
  };

  setLogEventsID = async () => {
    console.log("888");
    this.controllers.map(async (c) => {
      console.log("999");
      await apiRequest.getLogController(c.id);
    });
  };

  buildTimeColumn = (datatime) => {
    // datatime
  };

  createStructureHistoryParameters = async (data) => {
    // Временно
    this.setParameters("history_controller", []);
    this.setParameters("history_date", []);
    console.log("createStructureHistoryParameters");
    const rows = Array.isArray(data) ? data : [];
    rows.forEach((t) => {
      if (!t?.data) return;
      const id_tag = t.data.id_tag ?? t.tag?.id_tag;
      const name_tag = t.data.name_tag ?? t.tag?.name_tag;
      if (id_tag == null && !name_tag) return;

      const modDate = utilitState.ddmmyyyyhhmm(t.data.modification);
      // сбор даты
      const dateID = this.history_date.find((d) => d.date === modDate);
      if (!dateID) {
        this.history_date = [...this.history_date, { date: modDate }];
      }
      // сбор тегов
      const searhTagID = this.history_controller.find((col) =>
        id_tag != null ? col.id_tag === id_tag : col.name_tag === name_tag,
      );
      if (!searhTagID) {
        this.history_controller = [
          ...this.history_controller,
          {
            id_tag,
            name_tag,
            tag_active: true,
            data: [
              {
                parameter_value: t.data.parameter_value,
                descriptions: t.data.descriptions,
                modification: modDate,
              },
            ],
          },
        ];
      } else {
        // utilitState.ddmmyyyyhhmm(t.data.modification)
        searhTagID.data = [
          ...searhTagID.data,
          {
            parameter_value: t.data.parameter_value,
            descriptions: t.data.descriptions,
            modification: modDate,
          },
        ];
      }
    });
    // this.history_controller = this.history_controller;
    console.log(toJS(this.history_controller), toJS(this.history_date));
    this.history_controller_original = structuredClone(
      toJS(this.history_controller),
    );
    this.history_date_original = structuredClone(toJS(this.history_date));
    // return _data;
  };

  tagNameFiter = (tag) => {
    if (tag.length >= 2) {
      console.log(tag);
      this.history_controller = this.history_controller_original.filter((tf) =>
        tf.name_tag.toLowerCase().includes(tag.toLowerCase()),
      );
    } else {
      this.history_controller = this.history_controller_original;
    }
    this.sortAB(this.history_controller, "name_tag");
    console.log("!history_controller", toJS(this.history_controller));
  };

  applyHistoryDateFilter = (fromDate, toDate) => {
    if (!fromDate && !toDate) {
      this.history_date = this.history_date_original;
      return;
    }
    const fromMs = fromDate ? utilitState.datetimeLocalToMs(fromDate) : null;
    const toMs = toDate ? utilitState.datetimeLocalToMs(toDate) : null;
    this.history_date = this.history_date_original.filter((hd) => {
      const rowMs = utilitState.historyLabelToMs(hd.date);
      if (Number.isNaN(rowMs)) return false;
      if (fromMs != null && !Number.isNaN(fromMs) && rowMs < fromMs) {
        return false;
      }
      if (toMs != null && !Number.isNaN(toMs) && rowMs > toMs) {
        return false;
      }
      return true;
    });
  };

  dateHistoryFilter = (fromDate, toDate) => {
    try {
      this.applyHistoryDateFilter(fromDate, toDate);
    } catch (e) {
      console.error(e);
    }
  };

  tagHistoryFilter = () => {
    try {
      this.applyHistoryDateFilter(this.data_from, this.data_to);

      const tag = this.tag_value;
      if (tag.length !== 0) {
        console.log("!tag.length", tag.length);
        console.log(tag);
        this.history_controller = this.history_controller_original.filter(
          (tf) => tf.name_tag.toLowerCase().includes(tag.toLowerCase()),
        );
        this.sortAB(this.history_controller, "name_tag");
      } else {
        this.history_controller = this.history_controller_original;
        this.sortAB(this.history_controller, "name_tag");
      }

      console.log("!history_controller", toJS(this.history_controller));
    } catch (e) {
      console.error(e);
    }
  };

  viewHiddenTag = (tag) => {
    try {
      const tgaID = this.history_controller.find(
        (t) => tag.name_tag === t.name_tag,
      );
      if (tgaID) {
        tgaID.tag_active = !tgaID.tag_active;
      }
    } catch (e) {
      console.error(e);
    }
  };
}
export default new controllerState();
